<template>
  <tk-container
    class=" relative"
    :status="status"
    @refresh="init"
  >
    <div
      style="z-index: 9999;"
      class="fixed opacity-60 left-15 top-15
        square-30 flex-center cursor-pointer
        rounded-8 bg-white shadow shrink-0"
      slot="header"
      @click="onBack"
    >
      <van-icon name="arrow-left" />
    </div>
    <div class="p-0 w-full h-full">
      <div
        id="dplayer"
        class="w-full h-230 bg-black flex-center"
      >
        <van-loading
          v-if="status === 'loading'"
          size="24px"
          color="#fffff"
        >
          加载中...
        </van-loading>
      </div>
      <div class="p-15">
        <!-- 基本信息 -->
        <div class="text-13 font-bold line-height-22 line-2">
          {{ courseData.title }}
        </div>
        <div class="h-4 w-20 bg-orange" />
        <div
          v-if="subTitle"
          class="text-11 text-gray mt-8"
        >
          {{ subTitle }}
        </div>
        <!-- 课程目录 -->
        <div class="mt-15 text-13 font-bold line-height-22 line-2">
          课程目录
        </div>
        <div
          id="scrollbar"
          class="scrollbar h-88 overflow-x-scroll mt-15 w-full flex items-center"
        >
          <div
            v-for="(item, index) in videoList"
            :id="`card-video${index}`"
            :key="index"
            :class="[
              active === index ? 'border-solid border-orange border text-red bg-white' : '',
              index === videoList.length - 1 ? 'mr-0' : 'mr-15',
            ]"
            class="h-88 w-120 flex flex-shrink-0 flex-col justify-between rounded-10 bg-gray-F1F4F8 p-8 text-12 font-400"
            @click="toggleCourse(item, index)"
          >
            <div>
              <div>
                {{ ` 第${index + 1} 课` }}
              </div>
              <div class="mt-5 line-2">
                {{ item.name }}
              </div>
            </div>
            <div
              v-if="isRecordProgress"
              class="text-8"
            >
              <div v-if="item.percentage">
                {{ item.percentage >= 99 ? '已看完' : `上次看到${item.percentage}%` }}
              </div>
              <div v-else>
                上次看到0%
              </div>
            </div>
          </div>
        </div>
        <!-- 最近都在学 -->
        <div
          v-if="allCourses.length"
        >
          <div
            class="mb-12 mt-15 text-13 font-bold line-height-22 line-2"
          >
            最近都在学
          </div>
          <van-row
            :gutter="10"
          >
            <van-col
              v-for="(item, index) in allCourses"
              :key="index"
              span="12"
            >
              <course-card :data="item.course" />
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </tk-container>
</template>

<script
  type="text/javascript"
  src="https://player.dogecloud.com/js/loader"
></script>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'

export default {
  data () {
    return {
      status: 'loading',
      id: this.$route.query.id,
      courseData: {},
      vcode: this.$route.query.vcode || '',
      player: null,
      startTime: 0,
      allCourses: [],
      videoList: [],
      subTitle: ''
    }
  },
  computed: {
    ...mapState({
      isRecordProgress: state => state.isRecordProgress,
      user: state => state.user,
    }),
    active () {
      const index = this.videoList.findIndex((s) => {
        return s.vcode === this.vcode
      })
      if (index === -1) { return 0 }
      return index
    },
    poster () {
      const index = this.videoList.findIndex((s) => {
        return s.vcode === this.vcode
      })
      if (index === -1) { return '' }
      return this.videoList[index].poster || ''
    },
    progress () {
      const index = this.videoList.findIndex((s) => {
        return s.vcode === this.vcode
      })
      if (index === -1) { return 0 }
      return this.videoList[index].progress || 0
    }
  },
  activated() {
    this.init()
  },
  async beforeRouteLeave (to, from, next) {
    try {
      if (this.isRecordProgress) { await this.recordTime() }
      if (this.player) {
        this.player.pause()
        this.player.destroy()
        this.player.dp.destroy()
        this.player = null
      }
    } catch (e) {
      next(true)
      throw e
    }
    next(true)
  },
  methods: {
    async init () {
      await this.getDetail()
      await this.staticExchange()
      if (this.isRecordProgress) {
        await this.initCatalogueProgress()
      }
      this.status = false
      this.domScrollClient()
      this.initPlayer(this.active)
    },
    onBack () {
      this.$back()
    },
    async getDetail () {
      const { data: res } = await this.$tkParse.get(`/classes/courseList/${this.id}`).catch(async e => {
        Toast({
          message: '该课程不存在，即将返回',
          position: 'bottom',
        })
        await this.$tkHelper.promiseTimeout(1000)
        this.$back()
      })
      res.courseCatalog = res.courseCatalog || {
        type: false,
        list: [ {
          title: '',
          list: []
        } ]
      }
      this.courseData = res
      if (this.courseData.courseCatalog.type) {
        let list = this.courseData.courseCatalog.list.filter(s => {
          let index = s.list.findIndex(m => m.vcode === this.vcode)
          return index !== -1
        })
        if (list.length) {
          this.videoList = list[0].list
          this.subTitle = list[0].title
        }
        return
      }
      if (this.courseData.courseCatalog.list.length) {
        this.videoList = this.courseData.courseCatalog.list[0].list
      }
    },
    // | 最近都在学 | 统计兑换最多的前4种课
    async staticExchange () {
      this.allCourses = []
      const { data: res } = await this.$tkParse.get('/aggregate/exchangeRecord', {
        params: {
          group: {
            objectId: '$course',
            total: {
              $sum: 1,
            },
          },
          match: {
            status: '已使用',
          },
        },
      })
      if (res.results.length) {
        res.results.sort((a, b) => b.total - a.total)
        const spliceList = res.results.splice(0, 4)
        for (let i = 0; i < spliceList.length; i++) {
          const course = await this.$tkParse.getList(`/classes/courseList`, {
            params: {
              where: {
                objectId: spliceList[i].objectId,
              },
            },
          })
          if (course.length) {
            spliceList[i].course = course[0]
            this.allCourses.push({
              course: course[0]
            })
          }
        }
      }
    },
    // | 同步目录中的学习进度
    async initCatalogueProgress () {
      const batchRequest = []
      this.videoList.forEach((s) => {
        s.percentage = 0
        s.progress = 0
      })
      for (let i = 0; i < this.videoList.length; i++) {
        const request = this.$tkParse.getList('/classes/recordProgress', {
          params: {
            limit: 1,
            order: '-createdAt',
            where: {
              user: this.user.objectId,
              course: this.id,
              vcode: this.videoList[i].vcode,
            },
          },
        })
        batchRequest.push(request)
      }
      const result = await Promise.all(batchRequest)
      for (let i = 0; i < this.videoList.length; i++) {
        if (result[i].length) {
          this.videoList[i].percentage = result[i][0].percentage || 0
          this.videoList[i].progress = result[i][0].progress || 0
        } else {
          this.videoList[i].percentage = 0
          this.videoList[i].progress = 0
        }
      }
      this.$forceUpdate()
    },
    async initPlayer (index) {
      if (!this.vcode) { return }
      if (this.player) {
        this.player.pause()
        this.player.destroy()
        this.player.dp.destroy()
        this.player = null
      }
      this.player = new DogePlayer({
        container: document.getElementById('dplayer'),
        userId: 9382,
        // 测试userId
        // userId: 9340,
        vcode: this.vcode,
        start: this.progress,
        pic: this.poster,
        loop: true,
        autoPlay: true,
        events: {
          ready: async (p) => {
            if (this.$tkUa.isIos) {
              this.player.seek(this.progress)
              this.player.notice(`快进 ${Math.floor(this.progress)} 秒`, 2)
              return
            }
            this.player.pause()
            await this.$tkHelper.sleep(500)
            this.player.play()
            await this.$tkHelper.sleep(1000)
            if (this.player.playTime < this.progress) {
              this.player.seek(this.progress)
              this.player.notice(`快进 ${Math.floor(this.progress)} 秒`, 2)
            }
          },
          error: async (p) => {
            Toast({
              message: '视频加载失败',
              position: 'bottom'
            })
            await this.$tkHelper.sleep(1000)
            this.$back()
          },
        }
      })
    },
    // | 初始化将目录在可视区域展示
    domScrollClient () {
      const dom = document.getElementById('scrollbar')
      if (!dom) { return }
      const card = document.getElementById(`card-video${this.active}`)
      if (!card) { return }
      dom.scrollTo({
        left: card.offsetLeft - 100,
        behavior: 'smooth',
      })
    },
    // | 切换课
    async toggleCourse (item, index) {
      if (index === this.active) { return }
      this.vcode = this.videoList[index].vcode
      // 可视区域
      const dom = document.getElementById('scrollbar')
      if (!dom) { return }
      const card = document.getElementById(`card-video${index}`)
      if (!card) { return }
      // 添加动画
      dom.scrollTo({
        left: card.offsetLeft - 100,
        behavior: 'smooth',
      })
      this.initPlayer(index)
    },
    // | 返回记录观看时长
    async recordTime () {
      if (!this.player) { return }
      let time = this.player.playTime ? this.player.playTime : 0
      if (time < 10) { return }
      // 保留两位的小数
      const progressPercentage = (time / this.player.duration) * 100
      await this.$tkParse.post('/classes/recordProgress', {
        user: this.user.objectId,
        course: this.id,
        vcode: this.vcode,
        progress: this.player.playTime,
        percentage: Math.round(progressPercentage * 100) / 100,
      })
    }
  }
}
</script>

<style scoped lang="scss">
video {
  height: 230px;
  width: 100%;
}
</style>
<style>
.dplayer-download {
  display: none;
}
</style>
